<ng-container *ngIf="chartTitle">
    <div class="font-semibold" [ngClass]="'pl-1 pb-3'">
      {{ chartTitle }}
    </div>
    <div *ngIf="loading" class="flex align-items-center justify-content-center p-5">
      <p-progressSpinner ariaLabel="Loading chart" styleClass="w-4rem h-4rem" />
    </div>
    <div *ngIf="!loading && (!chartData?.datasets?.length)" class="p-5 text-center text-color-secondary">
      {{ noDataMessage }}
    </div>
    <div *ngIf="!loading && chartData?.datasets?.length">
      <p-chart type="line" [data]="chartData" [options]="chartOptions"></p-chart>
    </div>
</ng-container>

<div *ngIf="!chartTitle" class="charts" [class.dashboard]="isDashboardReport">
  <div *ngIf="charts?.bp?.datasets?.length"
       [ngClass]="isDashboardReport ? 'pl-1 chart' : 'p-5 chart-container'">
    <div class="font-semibold" [ngClass]="isDashboardReport ? 'pl-1 pb-3' : 'p-3 text-lg'">
      Blood Pressure
    </div>
    <p-chart type="line" [data]="charts?.bp" [options]="chartOptions"></p-chart>
  </div>

  <div *ngIf="charts?.glucose?.datasets?.length"
       [ngClass]="isDashboardReport ? 'pl-1 chart' : 'p-5 chart-container'">
    <div class="font-semibold" [ngClass]="isDashboardReport ? 'pl-1 pb-3' : 'p-3 text-lg'">
      Glucose level
    </div>
    <p-chart type="line" [data]="charts?.glucose" [options]="chartOptions"></p-chart>
  </div>

  <div *ngIf="!reviewModeLoading && !charts?.bp?.datasets?.length && !charts?.glucose?.datasets?.length" class="p-3 text-center text-color-secondary">
    {{ noDataMessage }}
  </div>
</div>